import React from 'react';
import { Text } from '@clockout-dev/design-elements';
import styles from '../styles/accessRulesCard.module.scss';

function AccessRulesReadOnlyNotice() {
    return (
        <div className={styles.readOnlyNotice} role="status">
            <Text as="span" size="xs" className={styles.readOnlyNoticeText}>
                Preview only — access rules cannot be saved yet. Values reflect the last loaded
                configuration.
            </Text>
        </div>
    );
}

export default AccessRulesReadOnlyNotice;
